import NovoPedido from "../components/NovoPedido";

export default function NovoPedidoPage(){
    return(
        <div className='bg-slate-300'>
                <div className=""><NovoPedido /></div>
        </div>
    )
}